
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from "vuex-class";
import { PreOrderListDto } from "@/api/buyCar";

@Component({
  name: 'MerchBill',
})
export default class MerchBill extends Vue {
  @Getter orderDtl!: PreOrderListDto

  labelWidth = 80
}
